import { HttpInterceptor, HttpRequest, HttpHandler } from "@angular/common/http";
import { Injectable } from "@angular/core";

import { ApiUrlService } from "../core/api-url";

/**
 * Ensures all requests to the backend include credentials (cookies).
 * Session is cookie-based (Better Auth); no Bearer token.
 */
@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private apiUrl: ApiUrlService) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler) {
    const backendUrl = this.apiUrl.rewriteBackendUrl(req.url);
    if (!backendUrl) {
      return next.handle(req);
    }
    const authRequest = req.clone({
      url: backendUrl,
      withCredentials: true,
    });
    return next.handle(authRequest);
  }
}
